import { useEffect, useMemo } from 'react';

/**
 * Custom hook that returns an `AbortSignal` instance.
 *
 * This hook creates a new `AbortController` using `useMemo` to ensure
 * that the same instance is used across renders. It also sets up a
 * cleanup effect using `useEffect` to abort the controller when the
 * component unmounts.
 *
 * @returns {AbortSignal} The `AbortSignal` instance from the `AbortController`.
 */
export const useAbortSignal = (): AbortSignal => {
    const abortController = useMemo(() => new AbortController(), []);

    useEffect(() => {
        return () => abortController.abort();
    }, [abortController]);

    return abortController.signal;
};
